import React from 'react'

import WebsiteText from '../../reusablePreviewComponents/WebsiteText'
import HeadlineText from '../../reusablePreviewComponents/HeadlineText'
import DescriptionText from '../../reusablePreviewComponents/DescriptionText'
import ActionButton from '../../reusablePreviewComponents/ActionButton'

import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  CALL_TO_ACTION,
  CALL_TO_ACTION_OPTION,
  DESCRIPTION_BLANK,
  DESCRIPTION_OPTION,
  HEADLINE_BLANK,
  HEADLINE_OPTION
} from '../../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

const FacebookSingleMediaAdFooter = ({ elementInProgress, formikValues }) => {
  const classes = useStyles()

  // ACTION BUTTON
  const actionValue = formikValues[CALL_TO_ACTION]
  const actionButtonInProgress = elementInProgress === CALL_TO_ACTION_OPTION

  // DESCRIPTION
  const descriptionText = formikValues[AD_DESCRIPTION]
  const descriptionBlank = formikValues[DESCRIPTION_OPTION] === DESCRIPTION_BLANK
  const descriptionInProgress = elementInProgress === DESCRIPTION_OPTION

  // HEADLINE
  const headlineText = formikValues[AD_HEADLINE]
  const isHeadlineBlank = formikValues[HEADLINE_OPTION] === HEADLINE_BLANK
  const headlineInProgress = elementInProgress === HEADLINE_OPTION

  return (
    <div className={classes.adFooter}>
      <div className={classes.footerInfo}>
        <div className={classes.footerWebsite}>
          <WebsiteText elementInProgress={elementInProgress} formikValues={formikValues} />
        </div>
        <HeadlineText
          headlineText={headlineText}
          isHeadlineBlank={isHeadlineBlank}
          isInProgress={headlineInProgress}
          className={classes.singleHeadlineText}
          skeletonClassName={classes.skeletonSingleHeadline}
        />
        <DescriptionText
          descriptionText={descriptionText}
          isDescriptionBlank={descriptionBlank}
          isInProgress={descriptionInProgress}
          className={classes.singleDescriptionText}
        />
      </div>
      <ActionButton
        actionValue={actionValue}
        isInProgress={actionButtonInProgress}
        className={classes.singleContentActionButton}
      />
    </div>
  )
}

export default FacebookSingleMediaAdFooter
